// Copyright (c) 2024 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/additionalUi"
import { ACTION_PANE_NOTE_IS_HIDDEN } from "./index"
import { ofType } from "redux-observable"

export type StorageReader = () => Observable<boolean>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(ACTION_PANE_NOTE_IS_HIDDEN)
    if (data !== null) {
      return of(data === "true")
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadActionPaneNoteIsHidden = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      ofType(Actions.loadActionPaneNoteIsHiddenFromStorage),
      mergeMap(_ => load().pipe(
        map(Slice.setActionPaneNoteIsHidden),
        catchError(_ => of(Actions.loadActionPaneNoteIsHiddenFromStorageFailed())),
      )),
    )

export default loadActionPaneNoteIsHidden(load)

